import { Component, Inject, OnInit } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { SignaturePositionModalComponent } from '../signature-position-modal/signature-position-modal.component';
import { FileUpload } from '../../document.interface';

@Component({
    selector: 'app-draft-validare',
    templateUrl: './draft-validare.component.html',
    styleUrls: ['./draft-validare.component.scss'],
})
export class DraftValidareComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    helper = helper;
    isAnexeLoading = false;
    isExemplarLoading = false;
    isLoading: boolean = false;

    validateDocumentForm!: FormGroup;

    uploading: any = {
        files_mesagerie_cetatean: false,
        files_mesagerie_intern: false,
        files_mesagerie_notita: false,
    };

    // Seal related properties
    canApplySeal: boolean = false;
    applySeal: boolean = false;
    sealPosition: any = null;
    isLoadingSealPreview: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            id: number;
            type: number;
            doc_type: number;
            canApplySeal?: boolean;
            documentUrl?: string;
        },
        private docService: DashboardService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<DraftValidareComponent>,
        private notificationService: NotificationService,
        public toastr: ToastrService,
        private dialog: MatDialog
    ) {
        console.log(this.data);
        this.canApplySeal = this.data.canApplySeal || false;
    }

    ngOnInit() {
        this.validateDocumentForm = this.fb.group({
            file: new FormControl(null, Validators.required),
            exemplarCetatean: new FormControl(null),
            anexe: this.fb.array([]),
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    removeFile() {
        this.validateDocumentForm.get('file')?.reset();
        const fileInput = document.getElementById(
            'upload-file-input-0'
        ) as HTMLInputElement;

        if (fileInput) {
            fileInput.value = '';
        }
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files || inputElement.files.length === 0) {
            return;
        }

        const file = inputElement.files[0];
        this.uploading.file = true;

        const formData = new FormData();
        formData.append('file', file, file.name);

        this.docService.fileUpload(formData).subscribe({
            next: (result: any) => {
                if (result && result.status_code === 200 && result.data) {
                    this.validateDocumentForm.get('file')?.setValue(result.data);

                    this.uploading.file = false;
                    this.openToast({
                        title: this.successTitle,
                        message: 'Fișierul dvs. a fost adăugat cu succes.',
                        type: this.successIcon,
                    });
                } else {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                    this.uploading.file = false;
                }
            },
            error: (error: any) => {
                this.isLoading = false;
                this.uploading.file = false;
                this.onHttpError(error);
            },
        });
    }

    addFileCetatean(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files || inputElement.files.length === 0) {
            return;
        }

        const file = inputElement.files[0];
        this.isExemplarLoading = true;

        const formData = new FormData();
        formData.append('exemplarCetatean', file, file.name);

        this.docService.fileUpload(formData).subscribe({
            next: (result: any) => {
                if (result && result.status_code === 200 && result.data) {
                    this.validateDocumentForm.get('exemplarCetatean')?.setValue(result.data);

                    this.isExemplarLoading = false;
                    this.openToast({
                        title: this.successTitle,
                        message: 'Fișierul dvs. a fost adăugat cu succes.',
                        type: this.successIcon,
                    });
                } else {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                    this.isExemplarLoading = false;
                }
            },
            error: (error: any) => {
                this.isLoading = false;
                this.isExemplarLoading = false;
                this.onHttpError(error);
            },
        });
    }

    submitDocumentSwitch() {
        if (this.data.type == 3) {
            // document official
            this.submitDocumentOficialSigned();
        } else {
            // document de validat
            this.submitDocumentValidare();
        }
    }

    submitDocumentValidare() {
        console.log(this.data.type);
        this.isLoading = true;
        console.log('document validare semnat final');

        const fileData = this.validateDocumentForm.get('file')?.value;
        const exemplarCetatean = this.validateDocumentForm.get('exemplarCetatean')?.value;

        const validateDoc = {
            files: [fileData],
            exemplarCetatean: [exemplarCetatean],
            type: this.data.type,
        };
        this.docService
            .validateDocument(this.data.id, this.data.type, validateDoc as any)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    submitDocumentOficialSigned() {
        this.isLoading = true;


        const fileData = this.validateDocumentForm.get('file')?.value;
        const anexe = this.validateDocumentForm.get('anexe')?.value;
        const exemplarCetatean = this.validateDocumentForm.get('exemplarCetatean')?.value;
        const type = this.data.type;

        const validateDoc = {
            files: [fileData],
            anexe: anexe,
            exemplarCetatean: [exemplarCetatean],
            type: type,
        };
        this.docService
            .uploadFinalDocument(this.data.id, validateDoc as any)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    addFilesRegistru(event: any, key: 'registruFile') {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const formFiles = this.validateDocumentForm.get('anexe')?.value;
            const fileExists = formFiles.some(
                (uploadedFile: FileUpload) => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.isAnexeLoading = true;

            const formData = new FormData();
            formData.append('registruFile', file, file.name);

            this.docService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.validateDocumentForm.get('anexe') as FormArray;
                            files.push(new FormControl(result.data));

                            this.isAnexeLoading = false;
                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.isAnexeLoading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.isAnexeLoading = false;
                    this.onHttpError(result.error);
                },
            });
        }

        // Reset the input value to allow re-uploading the same file
        inputElement.value = '';
    }

    removeFileRegistru(index: number) {
        const files = this.validateDocumentForm.get('anexe') as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    // ==================== Seal Related Methods ==================== //

    /**
     * Toggle apply seal checkbox
     */
    onApplySealChange(event: any): void {
        this.applySeal = event.checked;
        if (!this.applySeal) {
            this.sealPosition = null;
        }
    }

    /**
     * Open signature position modal to select seal placement
     */
    openSealPositionModal(): void {
        if (!this.validateDocumentForm.get('file')?.value) {
            this.notificationService.warningSwal(
                this.errorTitle,
                'Va rugam incarcati documentul inainte de a selecta pozitia sigiliului.',
                this.errorIcon
            );
            return;
        }

        this.isLoadingSealPreview = true;

        // Get document PDF blob for preview
        this.docService.downloadForSigning(this.data.id)
            .pipe(finalize(() => this.isLoadingSealPreview = false))
            .subscribe({
                next: (blob: Blob) => {
                    // Create object URL from blob
                    const documentUrl = URL.createObjectURL(blob);

                    const dialogRef = this.dialog.open(SignaturePositionModalComponent, {
                        minHeight: '80vh',
                        maxHeight: '90vh',
                        minWidth: '900px',
                        maxWidth: '95vw',
                        disableClose: true,
                        data: {
                            documentUrl: documentUrl,
                            documentId: this.data.id,
                            defaultWidth: 200,
                            defaultHeight: 75
                        },
                    });

                    dialogRef.afterClosed().subscribe((result: any) => {
                        // Revoke the object URL to free memory
                        URL.revokeObjectURL(documentUrl);

                        if (result?.success && result?.selection) {
                            this.sealPosition = result.selection;
                            this.openToast({
                                title: this.successTitle,
                                message: 'Pozitia sigiliului a fost selectata cu succes.',
                                type: this.successIcon,
                            });
                        }
                    });
                },
                error: (error: any) => {
                    console.error('Error loading document for signing:', error);
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        'Eroare la incarcarea documentului pentru previzualizare.',
                        this.errorIcon
                    );
                }
            });
    }

    /**
     * Clear seal selection
     */
    clearSealPosition(): void {
        this.sealPosition = null;
    }

    /**
     * Open seal position modal for EXISTING document (no upload required)
     */
    openSealPositionModalForExisting(): void {
        this.isLoadingSealPreview = true;

        console.log('[DraftValidare] Opening seal position modal for existing document, ID:', this.data.id);

        // Get existing document PDF blob from system (last signed document)
        this.docService.downloadForSigning(this.data.id)
            .pipe(finalize(() => this.isLoadingSealPreview = false))
            .subscribe({
                next: (blob: Blob) => {
                    console.log('[DraftValidare] Received blob:', blob);
                    console.log('[DraftValidare] Blob type:', blob.type);
                    console.log('[DraftValidare] Blob size:', blob.size);

                    // Check if blob is actually JSON error response
                    if (blob.type === 'application/json' || blob.size < 1000) {
                        // Try to read as text to see if it's an error
                        const reader = new FileReader();
                        reader.onload = () => {
                            console.error('[DraftValidare] Received error response instead of PDF:', reader.result);
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                'Eroare la incarcarea documentului: ' + reader.result,
                                this.errorIcon
                            );
                        };
                        reader.readAsText(blob);
                        return;
                    }

                    // Create object URL from blob
                    const documentUrl = URL.createObjectURL(blob);
                    console.log('[DraftValidare] Created blob URL:', documentUrl);

                    const dialogRef = this.dialog.open(SignaturePositionModalComponent, {
                        minHeight: '80vh',
                        maxHeight: '90vh',
                        minWidth: '900px',
                        maxWidth: '95vw',
                        disableClose: true,
                        data: {
                            documentUrl: documentUrl,
                            documentId: this.data.id,
                            defaultWidth: 200,
                            defaultHeight: 75
                        },
                    });

                    dialogRef.afterClosed().subscribe((result: any) => {
                        // Revoke the object URL to free memory
                        URL.revokeObjectURL(documentUrl);

                        if (result?.success && result?.selection) {
                            this.sealPosition = result.selection;
                            this.openToast({
                                title: this.successTitle,
                                message: 'Pozitia sigiliului a fost selectata cu succes.',
                                type: this.successIcon,
                            });
                        }
                    });
                },
                error: (error: any) => {
                    console.error('[DraftValidare] Error loading existing document:', error);
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        'Eroare la incarcarea documentului existent pentru previzualizare.',
                        this.errorIcon
                    );
                }
            });
    }

    /**
     * Get dynamic submit button label
     */
    getSubmitButtonLabel(): string {
        if (this.applySeal && this.sealPosition) {
            return 'Aplica Sigiliu';
        }
        return this.helper.dialogConfig.buttonLabels.save;
    }

    /**
     * Check if form is valid including seal requirements
     */
    isFormValidForSubmit(): boolean {
        // If seal mode is active, only need seal position
        if (this.applySeal) {
            return !!this.sealPosition;
        }
        // Otherwise, need file uploaded
        return !!this.validateDocumentForm.get('file')?.value;
    }

    /**
     * Submit document with seal if selected
     */
    submitWithSeal(): void {
        if (this.applySeal && this.sealPosition) {
            // Apply seal directly on existing document (no upload needed)
            this.applySealToExistingDocument();
        } else {
            this.submitDocumentSwitch();
        }
    }

    /**
     * Apply seal directly to existing document in system (no file upload)
     */
    private applySealToExistingDocument(): void {
        this.isLoading = true;

        console.log('[DraftValidare] Applying seal to existing document, position:', this.sealPosition);

        const sealData = {
            signature_config: {
                page: this.sealPosition.pageNumber,
                x: this.sealPosition.x,
                y: this.sealPosition.y,
                width: this.sealPosition.width,
                height: this.sealPosition.height
            }
        };

        this.docService.applySeal(this.data.id, sealData)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe({
                next: (res: any) => {
                    console.log('[DraftValidare] Seal applied successfully:', res);
                    this.openToast({
                        title: this.successTitle,
                        message: 'Sigiliul institutional a fost aplicat cu succes pe document.',
                        type: this.successIcon,
                    });
                    this.dialogRef.close({ success: true, sealApplied: true });
                },
                error: (err: any) => {
                    console.error('[DraftValidare] Error applying seal:', err);
                    let errorMessage = err?.error?.error || err?.error?.message || 'Eroare la aplicarea sigiliului institutional.';
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                }
            });
    }

    /**
     * Submit document official with institutional seal (when uploading new file + seal)
     */
    private submitDocumentWithSeal(): void {
        this.isLoading = true;

        const fileData = this.validateDocumentForm.get('file')?.value;
        const anexe = this.validateDocumentForm.get('anexe')?.value;
        const exemplarCetatean = this.validateDocumentForm.get('exemplarCetatean')?.value;

        // First upload the document
        const validateDoc = {
            files: [fileData],
            anexe: anexe,
            exemplarCetatean: [exemplarCetatean],
            type: this.data.type,
        };

        this.docService
            .uploadFinalDocument(this.data.id, validateDoc as any)
            .subscribe({
                next: (res: any) => {
                    // Now apply the seal
                    this.applySealToDocument();
                },
                error: (err: any) => {
                    this.isLoading = false;
                    let errorMessage = environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    /**
     * Apply institutional seal to the uploaded document
     */
    private applySealToDocument(): void {
        const sealData = {
            page_number: this.sealPosition.pageNumber,
            x: this.sealPosition.x,
            y: this.sealPosition.y,
            width: this.sealPosition.width,
            height: this.sealPosition.height
        };

        this.docService.applySeal(this.data.id, sealData)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe({
                next: (res: any) => {
                    this.openToast({
                        title: this.successTitle,
                        message: 'Documentul a fost incarcat si sigiliul a fost aplicat cu succes.',
                        type: this.successIcon,
                    });
                    this.dialogRef.close({ success: true, sealApplied: true });
                },
                error: (err: any) => {
                    console.error('Error applying seal:', err);
                    let errorMessage = err?.error?.message || 'Eroare la aplicarea sigiliului. Documentul a fost incarcat, dar sigiliul nu a fost aplicat.';
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                    // Still close with success since document was uploaded
                    this.dialogRef.close({ success: true, sealApplied: false });
                }
            });
    }
}
